import {Directive} from '@angular/core'
import {
  AbstractControl,
  NG_VALIDATORS,
  ValidationErrors,
  Validator
} from '@angular/forms'

export const phoneValidator = (control: AbstractControl): ValidationErrors | null => {
  const phoneNumber = control.value
  if (!/^[\d\s+()-]{8,20}$/.test(phoneNumber)) {
    return {
      error: {
        message: 'Vänligen kontrollera fältet'
      }
    }
  }
  return null
}

@Directive({
  selector: '[spbPhoneValidator]',
  providers: [
    {provide: NG_VALIDATORS, useExisting: PhoneValidatorDirective, multi: true}
  ]
})
export class PhoneValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    return phoneValidator(control)
  }
}
